export class AES {
  iv: string = '';
  value: string = '';
}
